import type { NotificationFormType } from '@/notificationForms'
import type { TestPhoneNotificationFormValues, TestValues } from '../types'

import { useCallback } from 'react'

import { testNotificationMessage } from '@/features/domain/territory'
import { useAppDispatch } from '@/store'

import { generateTestNotificationPayload } from './generateTestNotificationPayload'
import { useController } from './useController'

import { useIsUnmounted, useNotification } from '@/hooks'

export function useOnSubmit(notification: NotificationFormType, values: TestValues) {
  const dispatch = useAppDispatch()
  const toast = useNotification()
  const isUnMounted = useIsUnmounted()
  const { update } = useController()

  return useCallback(
    async (formValues: TestPhoneNotificationFormValues) => {
      try {
        const payload = generateTestNotificationPayload(
          notification,
          formValues.phoneNumber,
          values,
        )

        const thunkResult = await dispatch(testNotificationMessage(payload))

        if (!testNotificationMessage.fulfilled.match(thunkResult)) {
          throw new Error(thunkResult.payload?.message ?? 'Internal error')
        }

        update({ status: 'success' })

        if (isUnMounted()) return
      } catch (error) {
        toast.error(error.message)
        update({ status: 'error' })
      }
    },
    [dispatch, toast, notification, values, isUnMounted, update],
  )
}
